import { saveMyRewardsRoute } from '../actions'
import { DispatchFunction } from '../../types'

const doSaveMyRewardsRoute = (myRewardRoute: string) => (dispatch: DispatchFunction) => {
  dispatch(saveMyRewardsRoute(myRewardRoute))
}

export { doSaveMyRewardsRoute }
